import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

const DeleteTerminationModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body
        style={{
          textAlign: "center",
          padding: "30px 20px",
          backgroundColor: "#f3f4f6",
          borderRadius: "10px",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: "70px",
            height: "70px",
            margin: "0 auto 15px",
            background: "#fee2e2",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FiTrash2 size={30} color="#ef4444" />
        </div>

        {/* Title */}
        <h4
          style={{
            fontWeight: "600",
            color: "#1f2937",
            marginBottom: "10px",
          }}
        >
          Confirm Delete
        </h4>

        {/* Description */}
        <p
          style={{
            color: "#6b7280",
            fontSize: "14px",
            marginBottom: "25px",
          }}
        >
          You want to delete all the marked items, this cant be undone once you delete.
        </p>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <Button
            onClick={handleClose}
            style={{
              background: "#e5e7eb",
              border: "none",
              color: "#374151",
              padding: "8px 18px",
              borderRadius: "6px",
              fontWeight: "500",
            }}
          >
            Cancel
          </Button>

          <Button
            style={{
              background: "#ef4444",
              border: "none",
              padding: "8px 18px",
              borderRadius: "6px",
              fontWeight: "500",
            }}
          >
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteTerminationModal;